module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAMCAYAAACEJVa/AAAA8klEQVQ4T53STWoCQRCG4bcYCf4cICtxF5fxBIFRbEUU9Bwh4FUEIZucIVHHKGOCN8kiuM7GjaCdaWnGOAR1Rq1lNzxU1VfCNeWrHGtegQKOcy8XGxbYMMHwAOYbJ1W8DPkHsEBrl87863zkBGAnEXyV55cSjZl3crQYIEQ89Qa0QXq0/O4BlACEyKSqCGSIIY2YPs2Ppz10BhAitt5rdQJjO0oDz7Rmj/gqG6UQLfHYyNFivaoCBiAZkBfE3IUxxgNRJ3/8tF5BByMgu3vaxxh3T4cRj2suxtikftC6bO8g6SCP38ln5Zb1zYrGdJkE2P8t/Wd1GcqVCkMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hook.png
// module id = wzz6
// module chunks = 1